// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"17":"711fee34","447":"1550b803","453":"96a97019","552":"76e643d8","639":"e76effbf"}[chunkId] + ".chunk.js";
};